import { render, staticRenderFns } from "./VentasDolares.vue?vue&type=template&id=08789301&scoped=true&"
import script from "./VentasDolares.vue?vue&type=script&lang=js&"
export * from "./VentasDolares.vue?vue&type=script&lang=js&"
import style0 from "./VentasDolares.vue?vue&type=style&index=0&id=08789301&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08789301",
  null
  
)

export default component.exports